/// <amd-module name="Dashboards/WidgetContracts/Internal/WidgetContributionTypes" />
import { WidgetGridSize } from "./DashboardWidgetProps";

/**
 * New Platform Component Contribution properties members for Rendering Modern Widgets and Configs.
 */
export interface ContributionComponentProps {
    /**
     * Identifier of initializer to render legacy widget. Name must match up with VssComponent.register(...) entry of the widget.
     */
    componentType: string;

    /**
     * List of fully qualified contribution Ids required to properly instantiate the component.
     */
    includes: string[];
}

/**
 * Properties for Lightbox experiences.
 * Currently this contract is only honored with legacy Widgets.
 *
 * Note: Policy for handling of lightbox size in New platform is indeterminate at this stage.
 */
export interface WidgetContributionLightboxProps {
    /** Legacy-only property. Unsupport on New platform. */
    resizable: boolean;

    /**
     * width of lightbox, expressed in pixels
     */
    width: number;

    /**
     * height of lightbox, expressed in pixels
     */
    height: number;
}

/**
 * Aspects of Widget Contribution property object with significance for rendering of Widget, for consumption by WidgetHost.
 */
export interface WidgetContributionRenderingProps {
    /**
     * Identifier of contribution for new-platform rendering of Widget.
     */
    widgetComponentContributionId?: string;

    /**
     * Identifier of contribution for new-platform rendering of Config.
     */
    configComponentContributionId?: string;

    /**
     * (Opt-in property) Describes if a modern component contribution should be not be counted as such for page load purposes of Dashboard.
     * Widgets marked with this property still depend on legacy behaviors.
     */
    ignoreComponentContributionForDashboardLoad?: boolean;

    /**
     * Describes Lightbox configuration
     */
    lightbox?: WidgetContributionLightboxProps;

    /**
     * (Opt-out property) Describes if a Widget has settings which can refer to data outside the project containing the widget, which may be inappropriate to expose to anonymous & public users on Public projects.
     * Widgets which do not explicitly mark this as false are suppressed to said users, with settings data omitted at server side.
     */
    canStoreCrossProjectSettings?: boolean | undefined;

    /** Sizes supported by the widget. The first is used as a default in Configuration Experiences. */
    supportedSizes: WidgetGridSize[];
}
